"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _link = _interopRequireDefault(require("@meepshop/link"));

var _useButtonSettings2 = _interopRequireDefault(require("../../hooks/useButtonSettings"));

var _MenuGroup = _interopRequireDefault(require("./MenuGroup"));

require("./styles.less");

var styles = {
  "menu": "meepshop-meep-ui__submenu-largeMenu-styles__menu",
  "visible": "meepshop-meep-ui__submenu-largeMenu-styles__visible",
  "menuContent": "meepshop-meep-ui__submenu-largeMenu-styles__menuContent",
  "menuItem": "meepshop-meep-ui__submenu-largeMenu-styles__menuItem",
  "menuItemGroup": "meepshop-meep-ui__submenu-largeMenu-styles__menuItemGroup",
  "menuGroup": "meepshop-meep-ui__submenu-largeMenu-styles__menuGroup",
  "menuGroupContent": "meepshop-meep-ui__submenu-largeMenu-styles__menuGroupContent",
  "showThirdLevelMenuDivider": "meepshop-meep-ui__submenu-largeMenu-styles__showThirdLevelMenuDivider"
};

var MenuItem = function MenuItem(_ref) {
  var page = _ref.page,
      menuSettings = _ref.menuSettings,
      submenuSettings = _ref.submenuSettings;

  var _useButtonSettings = (0, _useButtonSettings2["default"])(page, {
    menuSettings: menuSettings
  }),
      title = _useButtonSettings.title,
      action = _useButtonSettings.action,
      isActive = _useButtonSettings.isActive,
      hasGroup = _useButtonSettings.hasGroup,
      url = _useButtonSettings.url,
      target = _useButtonSettings.target,
      isVisible = _useButtonSettings.isVisible;
  /* 頁面上下架狀態若下架，則不顯示 menu item */


  if (!isVisible) return null; // 有子選單

  if (hasGroup) {
    return /*#__PURE__*/_react["default"].createElement(_MenuGroup["default"], {
      page: page,
      menuSettings: menuSettings,
      submenuSettings: submenuSettings,
      MenuComponent: MenuItem
    });
  } // 有 action, 取代 url


  if (action) {
    return /*#__PURE__*/_react["default"].createElement("button", {
      className: styles.menuItem,
      style: {
        fontWeight: isActive ? 'bold' : 'normal'
      },
      onClick: action,
      type: "button"
    }, title);
  } // 一般的連結


  return /*#__PURE__*/_react["default"].createElement(_link["default"], {
    href: url,
    target: target,
    passHref: true
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: url,
    className: styles.menuItem,
    target: target,
    style: {
      fontWeight: isActive ? 'bold' : 'normal'
    }
  }, title));
};

var _default = MenuItem;
exports["default"] = _default;